import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Page, Question } from '../../../flow/models/flow.model';
import * as jp from "jsonpath/jsonpath";

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnInit {

    constructor(public _route: ActivatedRoute) { }

    public report: Page;
    public context: any;
    public reportLoaded: boolean = false;

    ngOnInit() {
        let inputForm = this._route.snapshot.data.workflow.states.find(x => x.stateType === 'inputForm');

        this.context = this._route.snapshot.data.workflow.context;
        //Only care about the first page of the form .. reports don't have multiple form pages, only a page, with data.
        this.report = inputForm.sections[0].pages[0];

        // for (let questionRow of this.report.questions) {
        //     for (let question of questionRow) {

        //         if (!question.label)
        //             continue;

        //         this.replaceContextValues(question);
        //     }
        // }

        setTimeout(() => this.reportLoaded = true, 100)
    }

    public replaceContextValues(question: Question): void {
        const contextKeyFormat = `$.data.`;
        for (let contextKey of Object.keys(this.context.data)) {
            let contextFormat = `${contextKeyFormat}${contextKey}`;
            let contextValue = jp.value(this.context, contextFormat).value;

            contextFormat = contextFormat.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            let regEx = new RegExp(contextFormat, 'g');

            question.label = question.label.replace(regEx, contextValue);
        }
    }
}
